import { render, staticRenderFns } from "./SingleArticleStatsSection.vue?vue&type=template&id=5137c09c"
import script from "./SingleArticleStatsSection.vue?vue&type=script&lang=ts"
export * from "./SingleArticleStatsSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports